import getCurrentRouteState from 'rlink-router/getCurrentRouteState';
import {globalBuildContext} from 'rlink-router/__globalBuildContextForLegacySupport__';

export default {
  getFullState () {
    let {
      view,
      params,
    } = getCurrentRouteState(globalBuildContext.reduxStore.getState().routing);
    return {
      view, params,
    };
  },
};



// WEBPACK FOOTER //
// ./lib/rlink-router/store.js